export default "__VITE_ASSET__BpLcBE1E__"